import { render, staticRenderFns } from "./LaundryItems.vue?vue&type=template&id=140657f9&scoped=true"
import script from "./LaundryItems.vue?vue&type=script&lang=js"
export * from "./LaundryItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140657f9",
  null
  
)

export default component.exports